var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.200293 1.60636C-0.428118 1.01287 0.566865 0.0731818 1.19528 0.716126L5.80362 5.01891C6.06546 5.2662 6.06546 5.71131 5.80362 5.9586L1.19528 10.3108C0.566865 10.9043 -0.428118 9.96464 0.200293 9.37115L4.28496 5.51348L0.200293 1.60636Z",
    fill: "#333232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.c1ffe5b64cbe5a73da8eaa748aeccc24.svg";
export { ForwardRef as ReactComponent };